module.exports = {
    SEARCH_CONTEXT: "search",
    MOST_POPULAR_CONTEXT: "most_popular",
    NEW_AND_NOTEABLE_CONTEXT: "new_and_notable"
};
